module.exports = __webpack_public_path__ + "static/media/how5.6499ed62.svg";